import { setStore, createStore } from 'hooks-for-redux'
import { compose } from 'redux'

const composeEnhancers =
process.env.NODE_ENV !== 'production' &&
(window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__() : compose

export default setStore(createStore({}, compose(composeEnhancers)))